import * as R from "ramda";

export const getFullAddress = R.prop("full_address");

export const getLatitude = R.prop("latitude");
export const getLongitude = R.prop("longitude");

export const isComplete = (a) => !!(a && getFullAddress(a) && a.latitude && a.longitude);
